import { createSelector } from 'reselect';

export const getDeviceGroups = state => state.device_groups;
export const isLoadingDeviceGroups = createSelector(getDeviceGroups, deviceGroups => deviceGroups.loading);
export const getDeviceGroupsError = createSelector(getDeviceGroups, deviceGroups => deviceGroups.error);

export const deviceGroupsItems = createSelector(getDeviceGroups, deviceGroups => deviceGroups.device_groups);
export const deviceGroupsColors = createSelector(getDeviceGroups, deviceGroups => deviceGroups.device_groups_colors);

